// extracted by mini-css-extract-plugin
export var blogTitle = "index-module--blog-title--XFO0f";
export var padBottom = "index-module--pad-bottom--UQFvd";